export default "__VITE_ASSET__CJm69CJu__"